import Dashboard from "../Components/Dashboard/Default";
import Users from "../Components/Application/Admin/Users/Users";
import Department from "../Components/Application/Admin/Department/Department";
import GroupRoom from "../Components/Application/Communication/GroupRoom/GroupRoom";
import Broadcast from "../Components/Application/Communication/Broadcast/Broadcast";
import RoomDetails from "../Components/Application/Communication/GroupRoom/RoomDetails";
import Security from "../Components/Application/Security/Security";
import MediaRepository from "../Components/Application/Project/Project";
import SystemSetting from "../Components/Application/SystemSetting/SystemSetting";
import HealthOperation from "../Components/Application/HealthOperation/HealthOperation";
import SupportCenter from "../Components/Application/SupportCenter/SupportCenter";
import MyProfile from "../Components/Application/Myprofile/MyProfile";
import Mapping from "../Components/Application/Admin/Whatsapp/Mapping/Mapping";
import Routing from "../Components/Application/Admin/Whatsapp/Routing/Routing";
import Auditlog from "../Components/AuditLogPage/Auditlog";
import Report from "../Components/Application/Project/Newproject";
import DocumentSecurity from "../Components/Application/Admin/DocumentSecurity/DocumentSecurity";
import TeamsGroups from "../Components/Application/Admin/TeamsGroups/TeamsGroups";
import Meetings from "../Components/Application/Admin/Meetings/Meetings";
import MeetingDetails from "../Components/Application/Admin/Meetings/MeetingDetails";
import BroadcastDetails from "../Components/Application/Communication/Broadcast/BroadcastDetails";

export const routes = [
  // Dashboard
  {
    path: `${process.env.PUBLIC_URL}/dashboard/:layout`,
    Component: <Dashboard />,
  },

  // Users
  {
    path: `${process.env.PUBLIC_URL}/users/:layout`,
    Component: <Users />,
  },

  // Departments
  {
    path: `${process.env.PUBLIC_URL}/departments/:layout`,
    Component: <Department />,
  },

  // Roles & Permissions
  {
    path: `${process.env.PUBLIC_URL}/roles/:layout`,
    Component: <Users />,
  },

  // Rooms
  {
    path: `${process.env.PUBLIC_URL}/rooms/:layout`,
    Component: <GroupRoom />,
  },

  // Room Details
  {
    path: `${process.env.PUBLIC_URL}/rooms/:roomId/:layout`,
    Component: <RoomDetails />,
  },

  // Broadcasts
  {
    path: `${process.env.PUBLIC_URL}/broadcasts/:layout`,
    Component: <Broadcast />,
  },
  // Broadcast Details
  {
    path: `${process.env.PUBLIC_URL}/broadcasts/:id/:layout`,
    Component: <BroadcastDetails />,
  },

  // WhatsApp Mappings
  {
    path: `${process.env.PUBLIC_URL}/whatsapp/mappings/:layout`,
    Component: <Mapping />,
  },

  // WhatsApp Routing Logs
  {
    path: `${process.env.PUBLIC_URL}/whatsapp/logs/:layout`,
    Component: <Routing />,
  },

  // Audit Logs
  {
    path: `${process.env.PUBLIC_URL}/audit/:layout`,
    Component: <Auditlog />,
  },

  // Media Repository
  {
    path: `${process.env.PUBLIC_URL}/media/:layout`,
    Component: <MediaRepository />,
  },

  // Reports
  {
    path: `${process.env.PUBLIC_URL}/reports/:layout`,
    Component: <Report />,
  },

  // Security
  {
    path: `${process.env.PUBLIC_URL}/security/:layout`,
    Component: <Security />,
  },
  {
    path: `${process.env.PUBLIC_URL}/document-security/:layout`,
    Component: <DocumentSecurity />,
  },

  // System Settings
  {
    path: `${process.env.PUBLIC_URL}/settings/:layout`,
    Component: <SystemSetting />,
  },

  // Health & Operations
  {
    path: `${process.env.PUBLIC_URL}/health/:layout`,
    Component: <HealthOperation />,
  },

  // Support Center
  {
    path: `${process.env.PUBLIC_URL}/support/:layout`,
    Component: <SupportCenter />,
  },

  // My Profile
  {
    path: `${process.env.PUBLIC_URL}/profile/:layout`,
    Component: <MyProfile />,
  },
  {
    path: `${process.env.PUBLIC_URL}/teams-groups/:layout`,
    Component: <TeamsGroups />,
  },
  {
    path: `${process.env.PUBLIC_URL}/meetings/:layout`,
    Component: <Meetings />,
  },
  {
    path: `${process.env.PUBLIC_URL}/meetings/:id/:layout`,
    Component: <MeetingDetails />,
  },

  // ========================================================
];
